var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { classNames } from 'libs/react';
import { useMutation } from 'libs/react';
import { useState } from 'libs/react';
import { Icon } from 'components/Icon';
import { Spinner } from 'components/Spinner';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import './FileButton.scss';
/**
 * @component FileButton
 * @since 1.0.0
 * @hidden
 */
export function FileButton(props) {
    const { exportMutation, isBinary, input, picto, label, style } = Object.assign({ isBinary: null, style: 'normal', picto: 'file-pdf' }, props);
    const [error, setError] = useState(null);
    const [processing, setProcessing] = useState(false);
    const [mutate] = useMutation(exportMutation);
    function download(dataurl, filename, binary) {
        const isBase64 = /^(?:[A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(dataurl);
        if (isBinary || isBase64) {
            const linkSource = `data:application/pdf;base64,${binary}`;
            const downloadLink = document.createElement('a');
            downloadLink.href = linkSource;
            downloadLink.download = filename;
            downloadLink.click();
            return;
        }
        const link = document.createElement('a');
        link.href = dataurl;
        //link.download = filename;
        link.target = '_blank';
        link.click();
    }
    /**
     * @function onClick
     * @since 1.0.0
     * @hidden
     */
    function onClick() {
        return __awaiter(this, void 0, void 0, function* () {
            if (processing)
                return;
            setProcessing(true);
            try {
                const result = yield mutate({
                    variables: {
                        input: Object.assign({}, input)
                    }
                });
                //TODO : Without this delay, sometimes file is not available yet
                setTimeout(function () {
                    if (!(result === null || result === void 0 ? void 0 : result.data))
                        return;
                    const fileResult = Object.values(result.data)[0];
                    download(fileResult.filepath, fileResult.filename, isBinary ? fileResult.filedata : null);
                    setProcessing(false);
                }, 1200);
            }
            catch (error) {
                setError(error);
                setProcessing(false);
                return;
            }
        });
    }
    const className = classNames('file-button', 'file-button--' + style, { 'file-button--has-error': error }, { 'file-button--is-processing': processing }, { 'file-button--has-label': label }, { 'file-button--has-picto': picto }, props.className);
    return (React.createElement("button", { className: className, onClick: onClick, type: "button" },
        React.createElement(Spinner, null),
        picto && React.createElement(Icon, { className: "file-button-picto", value: picto }),
        label && React.createElement(Text, { className: "file-button-label", value: label })));
}
